import type { ReactElement } from 'react';
import { useAuth } from 'react-oidc-context';

import { BrandSidebarWithHeader } from 'src/layouts/BrandSidebarWithHeader';
import { FullWidthConstrainedLayout } from 'src/layouts/FullWidthConstrainedLayout';

type ErrorsPageProps = {
  children: ReactElement[] | ReactElement;
};

export function ErrorsPage({ children }: ErrorsPageProps): ReactElement {
  const { user } = useAuth();

  return user ? (
    <BrandSidebarWithHeader>{children}</BrandSidebarWithHeader>
  ) : (
    <div className='flex h-screen w-screen overflow-hidden'>
      <div className='flex grow flex-col overflow-y-auto'>
        <FullWidthConstrainedLayout>{children}</FullWidthConstrainedLayout>
      </div>
    </div>
  );
}
